import { UpdateSubtypeRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdateCategoryRequest';
import { createSubtypeHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/SubtypeHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateSubtype = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createSubtypeHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateSubtypeRequest }) => {
      if (!repository) throw new Error('Repository not initialized');
      return await repository.update(id, data);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['subtypes'] });
      queryClient.invalidateQueries({ queryKey: ['subtype', variables.id] });
    },
  });
};
